import React, { createContext, useState, useContext } from 'react';

const BatteryConfigContext = createContext();

export const BatteryConfigProvider = ({ children }) => {
  const [selectedConfig, setSelectedConfig] = useState(null);

  return (
    <BatteryConfigContext.Provider value={{ selectedConfig, setSelectedConfig }}>
      {children}
    </BatteryConfigContext.Provider>
  );
};

export const useBatteryConfig = () => {
  return useContext(BatteryConfigContext);
};
